import { ILead, LeadsService } from '../../../services';

class LeadsInfoController {

    private onUpdate: any;
    private lead: ILead;
    private leadsService: any;

constructor(LeadsService: LeadsService, private $state: ng.ui.IStateService) {
        'ngInject';
        // console.log('LeadsInfoController');
        this.leadsService = LeadsService;
    }

    submitLead() {
        // console.log('update lead');

        if (this.lead.id == null) {
            this.saveLead();
        } else {
            this.leadsService.put(this.lead.id, this.lead);
        }
    }

    saveLead() {
        this.leadsService.post(this.lead).then(result => {
            this.onUpdate();
            (<any>$('#leadsModal')).modal('hide');
            //this.$state.go('crm.leads.list').then(() => { this.$state.reload(); });
        });
    }

    deleteLead() {
        // console.log('delete lead');
        this.leadsService.delete(this.lead.id);

        this.$state.go('^.list').then(() => { this.$state.reload(); });
    }
}

export const leadsInfoComponent = {
    bindings: {
        lead: '<',
        onUpdate: "&"
    },
    controller: LeadsInfoController,
    template: require('./leadsInfoModal.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/crm/leads/leadsInfoModal.component.ts